import React from 'react';
import {Grid, Typography} from "@mui/material";
import logoKozelMeeet from '../../assets/images/kozel_meet/meet_logo.png';
import useFirstScreenStyles from "../../styles/kozelMeetBoardGame/first_screen";
import TeaserBeMember from "./firstScreen/TeaserBeMember";
import {useAppSelector} from "../../stores/store";
import {paths} from "../../AppRouters";
import {NavLink} from "react-router-dom";
import InfoIcon from "@mui/icons-material/Info";
import clsx from "clsx";

const FirstScreen: React.FC = () => {
    const styles = useFirstScreenStyles();
    const {isAuthenticated} = useAppSelector(state => state.auth);
    return (
        <Grid container
              flexDirection={'column'}
              alignItems={"center"}
              alignContent={"center"}
              justifyContent={"center"}
              className={clsx(styles.bgDarkChoco,styles.container)}
        >
            <Grid item xs={10} lg={4} mt={2} textAlign={'center'}>
                <img src={logoKozelMeeet} alt={'Logo Kozel meeet'} className={styles.logoKozelMeet} style={{ maxWidth: '430px', maxHeight: '235px'}}/>
            </Grid>
            <Grid item xs={10} lg={4} mt={2}>
                <Typography className={styles.subtitle}>There’s always room for
                    <span className={styles.colorDesertSandGold}> one more!</span></Typography>
            </Grid>
            <Grid item xs={12} lg={10} mt={4} mb={5}>
                <TeaserBeMember/>
            </Grid>
            {!isAuthenticated && (
                <>
                    <Grid item xs={12} lg={6}>
                        <Typography className={styles.subtitle2}>I invite you to be part of the Kozel Meeet community and celebrate every meeting with your group, with ȚAPĂN beer from the Czech Republic!</Typography>
                    </Grid>
                    <Grid item xs={12} lg={6} mt={5}>
                        <NavLink to={paths.register} className={styles.button}>Become a member</NavLink>
                    </Grid>
                    <Grid item xs={12} lg={8} mt={5}>
                        <Typography className={styles.textBenefits}><InfoIcon className={styles.contentTeaserListItemIcon}/>joining the community automatically brings you 50 points</Typography>
                    </Grid>
                </>
            )}
        </Grid>
    );
}

export default FirstScreen;
